// Import dependencies
import initialiser from '../../utils/initialiser';

const defaultSettings = {
  activeClass: 'is-active',
  menuOpenClassWhite: 'c-header--white-background',
  menuOpenClassNone: 'c-header--transparent-background',
};

class Search {
  constructor(config) {
    const { el, settings } = config;
    const {
      trigger, close, input, headerBackground, ...settingsWithoutSelectors
    } = settings;

    // Set root element
    this.overlay = el;
    this.trigger = document.querySelector(trigger);
    this.close = el.querySelector(close);
    this.input = el.querySelector(input);
    this.headerBackground = document.querySelector(headerBackground);

    // Set settings
    this.settings = { ...defaultSettings, ...settingsWithoutSelectors };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.trigger || !this.close || !this.input) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    this.trigger.addEventListener('click', this.activateOverlay);
    this.close.addEventListener('click', this.deactivateOverlay);
    document.addEventListener('keyup', this.handleKeyPress);
  };

  handleKeyPress = (e) => {
    // escape key.
    if (e.keyCode === 27) {
      this.deactivateOverlay();
    }
  };

  activateOverlay = () => {
    this.overlay.classList.toggle(this.settings.activeClass);

    if (this.headerBackground) {
      this.headerBackground.classList.remove(this.settings.menuOpenClassWhite);
      this.headerBackground.classList.add(this.settings.menuOpenClassNone);
    }

    if (this.overlay.classList.contains(this.settings.activeClass)) {
      if (this.headerBackground) {
        this.headerBackground.classList.remove(this.settings.menuOpenClassNone);
        this.headerBackground.classList.add(this.settings.menuOpenClassWhite);
      }
    }

    if (document.documentElement.classList.contains('touchevents')) return;

    setTimeout(() => {
      this.input.focus();
    }, 600);
  };

  deactivateOverlay = () => {
    this.overlay.classList.remove(this.settings.activeClass);
    if (this.headerBackground) {
      this.headerBackground.classList.remove(this.settings.menuOpenClassWhite);
      this.headerBackground.classList.add(this.settings.menuOpenClassNone);
    }

    this.input.blur();

    setTimeout(() => {
      this.input.value = '';
    }, 600);
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Search);
